import * as React from 'react';
import { Checkbox } from '@osui/ui';
import { isCheckedMap } from '../Other/Field/utils';
import { useFieldContext } from '../Other';

const enable = opt => {
  var _opt$props, _opt$props2;

  if (!opt.selectFirst) {
    return false;
  }

  if (isCheckedMap(opt.childrenType)) {
    return false;
  }

  if (((_opt$props = opt.props) === null || _opt$props === void 0 ? void 0 : _opt$props.options) == null) {
    return false;
  }

  if (((_opt$props2 = opt.props) === null || _opt$props2 === void 0 ? void 0 : _opt$props2.mode) === 'multiple') {
    return false;
  }

  if (opt.childrenType === Checkbox.Group) {
    return false;
  }

  return true;
};

const isStringOrNumber = v => typeof v === 'string' || typeof v === 'number';

export const useSelectFirst = props => {
  var _props$children, _props$selectFirst;

  const childrenType = (_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.type;
  const res = useFieldContext();
  const selectFirst = (_props$selectFirst = props.selectFirst) !== null && _props$selectFirst !== void 0 ? _props$selectFirst : true;
  const value = props.value;
  React.useEffect(() => {
    var _props$options;

    if (!enable({
      selectFirst,
      childrenType,
      props
    })) {
      return;
    }

    const options = (_props$options = props.options) !== null && _props$options !== void 0 ? _props$options : []; // 如果value在options里，就不默认选中第一个了

    if (value != null) {
      const item = options.find(v => {
        if (isStringOrNumber(v)) {
          return v === value;
        }

        return v.value === value;
      });

      if (item) {
        return;
      }
    }

    const first = options.find(opt => isStringOrNumber(opt) || opt.disabled !== true);
    const firstValue = first ? isStringOrNumber(first) ? first : first.value : undefined;
    res.form.setFieldState(res.preName, s => {
      s.value = firstValue;
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.options]);
};
//# sourceMappingURL=es/hooks/useSelectFirst.js.map